import { render, staticRenderFns } from "./im-team-turn.vue?vue&type=template&id=3194529a"
import script from "./im-team-turn.vue?vue&type=script&lang=js"
export * from "./im-team-turn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3194529a')) {
      api.createRecord('3194529a', component.options)
    } else {
      api.reload('3194529a', component.options)
    }
    module.hot.accept("./im-team-turn.vue?vue&type=template&id=3194529a", function () {
      api.rerender('3194529a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/group/im-team-turn.vue"
export default component.exports